import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTDeleteAPIGuildTemplateResult,
	RESTGetAPIGuildTemplatesResult,
	RESTGetAPITemplateResult,
	RESTPatchAPIGuildTemplateJSONBody,
	RESTPatchAPIGuildTemplateResult,
	RESTPostAPIGuildTemplatesJSONBody,
	RESTPostAPIGuildTemplatesResult,
	RESTPostAPITemplateCreateGuildJSONBody,
	RESTPostAPITemplateCreateGuildResult,
	RESTPutAPIGuildTemplateSyncResult
} from "discord-api-types/v10";





class GuildTemplateMethods {








	public constructor(public requestHandler: RH) {}











	public async getGuildTemplate(code: string): Promise<RESTGetAPITemplateResult> {
		return this.requestHandler.request(Endpoints.TEMPLATE(code), {}, "get", "json");
	}












	public async createGuildFromGuildTemplate(code: string, options: RESTPostAPITemplateCreateGuildJSONBody): Promise<RESTPostAPITemplateCreateGuildResult> {
		return this.requestHandler.request(Endpoints.TEMPLATE(code), {}, "post", "json", options);
	}















	public async getGuildTemplates(guildId: string): Promise<RESTGetAPIGuildTemplatesResult> {
		return this.requestHandler.request(Endpoints.GUILD_TEMPLATES(guildId), {}, "get", "json");
	}
















	public async createGuildTemplate(guildId: string, data: RESTPostAPIGuildTemplatesJSONBody): Promise<RESTPostAPIGuildTemplatesResult> {
		return this.requestHandler.request(Endpoints.GUILD_TEMPLATES(guildId), {}, "post", "json", data);
	}
















	public async syncGuildTemplate(guildId: string, code: string): Promise<RESTPutAPIGuildTemplateSyncResult> {
		return this.requestHandler.request(Endpoints.GUILD_TEMPLATE(guildId, code), {}, "put", "json");
	}

















	public async modifyGuildTemplate(guildId: string, code: string, data: RESTPatchAPIGuildTemplateJSONBody): Promise<RESTPatchAPIGuildTemplateResult> {
		return this.requestHandler.request(Endpoints.GUILD_TEMPLATE(guildId, code), {}, "patch", "json", data);
	}
















	public async deleteGuildTemplate(guildId: string, code: string): Promise<RESTDeleteAPIGuildTemplateResult> {
		return this.requestHandler.request(Endpoints.GUILD_TEMPLATE(guildId, code), {}, "delete", "json");
	}
}

export = GuildTemplateMethods;
